"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _initializerDefineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/initializerDefineProperty.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/applyDecoratedDescriptor.js"));
var _initializerWarningHelper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/initializerWarningHelper.js"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _product = require("@/types/product");
require("../../../../public/custom-print.css");
var _initStore = require("@/store/initStore");
var _enum = require("@/utils/enum");
var _dec, _class, _class2, _descriptor; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ExportWarehousePrint = exports.default = (_dec = (0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: function _default() {
    return {};
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  function ExportWarehousePrint() {
    var _this;
    (0, _classCallCheck2.default)(this, ExportWarehousePrint);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ExportWarehousePrint, [].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, _this);
    (0, _defineProperty2.default)(_this, "UnitTrans", _product.UnitTrans);
    (0, _defineProperty2.default)(_this, "totalPrice", 0);
    (0, _defineProperty2.default)(_this, "totalQuantity", 0);
    (0, _defineProperty2.default)(_this, "ConfigurationParam", _enum.ConfigurationParam);
    (0, _defineProperty2.default)(_this, "realDate", "");
    (0, _defineProperty2.default)(_this, "ExportWarehouseType", _enum.ExportWarehouseType);
    return _this;
  }
  (0, _inherits2.default)(ExportWarehousePrint, _Vue);
  return (0, _createClass2.default)(ExportWarehousePrint, [{
    key: "configurationList",
    get: function get() {
      return _initStore.configurationStore.list;
    }
  }, {
    key: "taxPercent",
    get: function get() {
      console.log('this.configurationList["VAT_FACTOR"]:', this.configurationList["VAT_FACTOR"]);
      if (this.configurationList["VAT_FACTOR"]) {
        return this.configurationList["VAT_FACTOR"].value * 100;
      }
      return 10;
    }
  }, {
    key: "titleExportBill",
    get: function get() {
      var Consign = [_enum.ExportWarehouseType.DepositGift, _enum.ExportWarehouseType.DepositOrder, _enum.ExportWarehouseType.ConsignOrder, _enum.ExportWarehouseType.ConsignGiveaway];
      if (Consign.includes(this.data.type)) {
        return " KÝ GỬI";
      }
      if (this.data.type == _enum.ExportWarehouseType.Giveaway) {
        return " KHÁC";
      }
      return "";
    }
  }, {
    key: "labelReasonExport",
    get: function get() {
      var Consign = [_enum.ExportWarehouseType.DepositGift, _enum.ExportWarehouseType.DepositOrder, _enum.ExportWarehouseType.ConsignOrder, _enum.ExportWarehouseType.ConsignGiveaway];
      if (Consign.includes(this.data.type)) {
        return "Xuất kho ký gửi";
      }
      return "Lý do xuất kho";
    }
  }, {
    key: "table",
    get: function get() {
      var _this2 = this;
      var data = [];
      var stt = 1;
      this.totalPrice = 0;
      this.totalQuantity = 0;
      this.data.products.forEach(function (product) {
        if (!product.product.isPublished) {
          return;
        }
        if (product.orderDetail) {
          if (product.orderDetail.discountPercent) {
            product.realPrice = product.product.retailPrice - product.product.retailPrice * product.orderDetail.discountPercent / 100;
          } else {
            product.realPrice = product.product.retailPrice - product.orderDetail.discountAmount;
          }
        } else {
          product.realPrice = product.product.retailPrice;
        }
        data.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, product), {}, {
          stt: stt
        }));
        stt++;
        _this2.totalPrice += product.exportQuantity * product.realPrice;
        _this2.totalQuantity += product.exportQuantity;
      });
      return data;
    }
  }, {
    key: "transformDate",
    get: function get() {
      var finalDate = this.realDate || this.data.date;
      return "Ng\xE0y ".concat((0, _moment.default)(finalDate).format("DD"), " th\xE1ng ").concat((0, _moment.default)(finalDate).format("MM"), " n\u0103m ").concat((0, _moment.default)(finalDate).format("YYYY"));
    }
  }, {
    key: "infoOrder",
    get: function get() {
      return this.data.order || this.data.giveaway;
    }
  }, {
    key: "handlePrint",
    value: function handlePrint(realDate) {
      var _this3 = this;
      if (realDate) {
        this.realDate = realDate;
      }
      setTimeout(function () {
        _this3.$htmlToPaper("print-export-warehouse", {
          name: "_blank",
          specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
          styles: ["/custom-print.css"]
        });
      });
    }
  }]);
}(_vuePropertyDecorator.Vue), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);